import { useContext } from 'react'

import AuthTrainingContext from 'contexts/AuthTrainingContext'

const useAuthTraining = () => {
  const context = useContext(AuthTrainingContext)

  if (context === undefined) {
    throw new Error(
      'useAuthTraining must be used within AuthTrainingContext.Provider',
    )
  }

  return {
    accessType: context.accessType,
    company: context.company,
    linkInvalid: context.linkInvalid,
    loaded: context.loaded,
    loginMode: context.loginMode,
    portalToken: context.portalToken,
    theme: context.theme,
  }
}

export default useAuthTraining
